import React from 'react';
import GenericTabs from '../../../../../ui-components/Tabs/GenericTabs';

interface DirectionTabsProps {
  direction: 'INBOUND' | 'OUTBOUND';
  onDirectionChange: (direction: 'INBOUND' | 'OUTBOUND') => void;
}

export const DirectionTabs: React.FC<DirectionTabsProps> = ({
  direction,
  onDirectionChange
}) => {
  return (
    // GenericTabs always stretches its own container to `w-full`; the `w-max` wrapper is what
    // makes it size to its two labels so it can sit in a flex toolbar row without eating it.
    <div className="w-max flex-shrink-0">
      <GenericTabs
        tabs={[
          { label: 'Inbound', value: 'INBOUND' },
          { label: 'Outbound', value: 'OUTBOUND' }
        ]}
        activeTab={direction}
        onTabChange={(value: string) => onDirectionChange(value as 'INBOUND' | 'OUTBOUND')}
        size="xs"
        fullWidth={false}
        fitContent
        aria-label="Route direction"
      />
    </div>
  );
};
